import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.5 15.817-4.243-4.242a6 6 0 1 1 8.486 0zm3.3-5.185a4.666 4.666 0 1 0-6.6 0l3.3 3.3zM8.5 8.665A1.333 1.333 0 1 1 8.5 6a1.333 1.333 0 0 1 0 2.666"
    }, null, -1)
  ]))]))
}
export default { render: render }